import { ArrowRightIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { employersVerificationOwnerInvitationInvitationFormApp } from 'rails_routes'
import { Banner } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

export const OwnerIdentificationBanner = forwardRef<HTMLDivElement>((_props, forwardedRef) => {
  const { assign } = useWindowLocation()

  const handleClick = () => {
    assign(employersVerificationOwnerInvitationInvitationFormApp.index())
  }

  return (
    <div className='pb-10' ref={forwardedRef}>
      <Banner
        cta={
          <button
            className='flex items-center gap-2 text-orange-500 body-sm-bold hover:text-orange-600 transition-colors'
            onClick={handleClick}
            type='button'
          >
            <span className='border-b border-dotted border-orange-500 hover:border-orange-600'>
              Submit required information
            </span>
            <ArrowRightIcon size={16} />
          </button>
        }
        title='Important business verification information required'
        type='warning'
      />
    </div>
  )
})
